<template>
  <div v-if="visible" class="message-overlay">
    <div class="message-container">
      <div class="message-content">
        {{ title }}
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Message",
  props: {
    title: {
      type: String,
      default: "",
    },
    duration: {
      type: Number,
      default: 2000,
    },
  },
  data() {
    return {
      visible: false,
    };
  },
  methods: {
    show() {
      this.visible = true;
      setTimeout(() => {
        this.visible = false;
      }, this.duration);
    },
    hide() {
      this.visible = false;
    },
  },
};
</script>

<style lang="scss" scoped>
.message-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 9999;
}

.message-container {
  background: rgba(0, 0, 0, 0.8);
  border-radius: 8px;
  width: 181px;
  padding: 40px 20px;
  font-size: 14px;
  font-weight: bold;
  color: #fff;
}

.message-content {
  color: #fff;
  font-size: 16px;
  text-align: center;
  line-height: 1.5;
}
</style>
